import { css } from 'styled-components';

const styles = css`
  &.syte-recommendations {
    margin: auto;
    width: 100%;

    .syte-slider-arrows-container {
      align-items: flex-start;
      padding-top: 115px;
    }

    @media only screen and (min-width: 360px) and (max-width: 767px) {
      .splide__list {
        width: 300px;
      }
    }

    @media only screen and (min-width: 768px) {
      width: 90%;
      .syte-slider-arrow.syte-slider-arrow-left {
        left: -10px !important;
      }
      .syte-slider-arrow.syte-slider-arrow-right {
        right: -10px !important;
      }
    }
    @media only screen and (min-width: 1200px) {
      border-top: 1px solid #f3f3f3;
      .syte-slider-arrow.syte-slider-arrow-left {
        left: -20px !important;
      }
      .syte-slider-arrow.syte-slider-arrow-right {
        right: -20px !important;
      }
    }
  }
`;

export default styles;
